<template>
  <div>
    <el-card class="box-card" v-loading="loading">
      <div slot="header" class="box-header">
        <span class="box-header__title">Рассписание пушей</span>
        <div>
          <el-button
            name="add"
            class="box-header__button"
            @click="addData"
            size="mini"
            type="primary"
          >Добавить
          </el-button>
          <el-button
            name="add"
            class="box-header__button"
            @click="loadLogic"
            icon="el-icon-refresh-right"
            size="mini"
          >
          </el-button>
        </div>
      </div>

      <template>
        <el-table :data="tableData" class="table">
          <el-table-column prop="id" label="id"></el-table-column>
          <el-table-column label="Клиент+">
            <template slot-scope="scope">
              <el-link type="primary" :href="`/users/${scope.row.user.id}`" v-if="scope.row.user" target="_blank">id{{
                  scope.row.user.id
                }}
                {{ scope.row.user.name }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column label="updated_at">
            <template slot-scope="scope" v-if="scope.row.send_at">
              {{ $root.dateIso(scope.row.send_at) }}
            </template>
          </el-table-column>
          <el-table-column label="data">
            <template slot-scope="scope" v-if="scope.row.data">
              {{
                scope.row.data
              }}
            </template>
          </el-table-column>
          <el-table-column label="Title" prop="title"></el-table-column>
          <el-table-column label="Body" prop="body"></el-table-column>
          <el-table-column fixed="right" align="center" width="140" label="Действия">
            <template slot-scope="scope">
              <el-tooltip content="Просмотр" placement="top">
                <el-button
                  class="table__btn"
                  size="mini"
                  type="primary"
                  icon="el-icon-view"
                  circle
                  @click="editData(scope.row)"
                />
              </el-tooltip>

            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          v-if="showPagination"
          class="pagination"
          background
          layout="prev, pager, next"
          :page-size="pagination.per_page"
          :total="pagination.total"
          :current-page="pagination.current_page"
          @current-change="loadLogic"
        ></el-pagination>

      </template>
      <div class="error-load" v-if="errorLoadCard">
        <p>Ошибка загрузки</p>
        <el-button type="danger" @click="loadLogic">Загрузить еще раз</el-button>
      </div>
    </el-card>

    <push-add
      :visible="dataAddModal"
      @close="dataAddModal = false"
      @update="loadLogic"
    />
    <push-view
      :visible="dataEditModal"
      @close="dataEditModal = false"
      @update="loadLogic"
      :data="selectData"
    />

  </div>
</template>

<script>
import PushAdd from '@/components/dialog/push/Add'
import PushView from '@/components/dialog/push/View'

export default {
  name: 'Push.Schedule',
  data () {
    return {
      tableData: null,
      loading: false,
      errorLoadCard: false,
      worker: {
        title: null,
        description: null
      },
      error: null,
      selectData: false,
      dataEditModal: false,
      dataAddModal: false,
      pagination: null
    }
  },
  created () {
    this.loadLogic()
  },
  computed: {
    showPagination () {
      if (this.pagination) {
        return this.pagination.total > this.pagination.per_page
      } else {
        return false
      }
    }
  },
  components: { PushAdd, PushView },
  methods: {
    loadLogic (page = 0) {
      this.loading = true
      const params = {
        params: {
          page
        }
      }

      this.$api.push
        .getPushSchedule(params)
        .then((response) => {
          this.tableData = response.data.data
          if (response.data.meta) this.pagination = response.data.meta.pagination
        })
        .catch((response) => {
          this.$notify.error({
            title: 'Ошибка загрузки списка',
            message: response.response.data.message
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    editData (id) {
      this.selectData = id

      this.dataEditModal = true
    },
    addData () {
      this.dataAddModal = true
    }

  }
}
</script>

<style scoped lang="scss">
.box-card {
  max-width: 1960px;
  margin: 0 auto;

  &__title {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    color: #aaaeba;
    margin: 5px 0 40px 0;
  }

  &__btns {
    text-align: center;
    margin: 50px 0 0 0;
  }
}

.table {
  width: 100%;

  &__btn {
    margin: 5px;
  }
}

.box-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.box-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pagination {
  margin-top: 10px;
  padding: 0;
}
</style>
